import { render, staticRenderFns } from "./AdvProductCard.vue?vue&type=template&id=337f9164&scoped=true"
import script from "./AdvProductCard.vue?vue&type=script&lang=js"
export * from "./AdvProductCard.vue?vue&type=script&lang=js"
import style0 from "./AdvProductCard.vue?vue&type=style&index=0&id=337f9164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f9164",
  null
  
)

export default component.exports